import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/view/license.plan.featureGroups.query.gql"
import type {
  LicensePlanFeatureGroupsQuery,
  LicensePlanFeatureGroupsQueryVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.featureGroups.query"

type Options = QueryHookOptions<
  LicensePlanFeatureGroupsQuery,
  LicensePlanFeatureGroupsQueryVariables
>

export function useLicensePlanFeatureGroupsQuery(options?: Options) {
  return useQuery<
    LicensePlanFeatureGroupsQuery,
    LicensePlanFeatureGroupsQueryVariables
  >(query, options)
}
